import React, { useEffect, useState } from "react";
import API from "../Services/TaxRate";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DataTable from "react-data-table-component";
import "../Styles/table1.css";
const TaxRateList = () => {
  const [taxRate, setTaxRate] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const perPage = 10;

  const [id, setId] = useState([]);
  const [type, setType] = useState("");
  const [rate, setRate] = useState("");
  const [cess, setCess] = useState("");
  const [entertainment, setEntertainment] = useState("");
  const [otherTax, setOtherTax] = useState("");
  const [getStatus, setGetStatus] = useState("");
  const [createdDate, setCreatedDate] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");

  useEffect(() => {
    bindGetTaxtRate();
  }, [currentPage, selectedStatus]);

  const bindGetTaxtRate = async () => {
    try {
      const basePayload = {
        limit: perPage,
        pageNumber: currentPage,
        is_recipe: 0,
      };

      if (selectedStatus !== "") {
        basePayload.is_active = selectedStatus;
      }

      const response = await API.getTaxRate(basePayload);
      const details = response?.data?.data;

      setTaxRate(details?.rows || []);
      setTotalRecords(details?.count ?? 0);
    } catch (error) {
      toast.dismiss();
      if (!error.response) {
        toast.error("Network error! Please check your internet connection.");
      } else if (error.response.status === 403) {
        window.location.replace("/Login");
        toast.error("Authorization error. Redirecting to login.");
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleStatusToggle = async (id, currentStatus) => {
    const updatedStatus = !currentStatus;
    try {
      const response = await API.changeTaxStatus(id, updatedStatus);
      if (response.status === 200) {
        setTaxRate((prev) =>
          prev.map((item) =>
            item.id === id ? { ...item, is_active: updatedStatus } : item
          )
        );
        toast.success(response.data.message);
        bindGetTaxtRate();
      } else {
        toast.error("Failed to update the status. Please try again.");
      }
    } catch (error) {
      if (error.response?.status === 403) {
        window.location.replace("/Login");
      }
      toast.error("Failed to update the status. Please try again.");
    }
  };

  const handleGetData = async (id) => {
    try {
      setId(id);
      const response = await API.getTaxRate({ id: id });
      const fetchedData = response?.data.data.rows?.[0];
      if (fetchedData) {
        setType(fetchedData?.type);
        setRate(fetchedData?.rate);
        setCess(fetchedData?.cess);
        setGetStatus(fetchedData?.is_active);
        setEntertainment(fetchedData?.entertainment_tax);
        setOtherTax(fetchedData?.other_tax);
        setCreatedDate(fetchedData?.createdAt);
      } else {
        toast.error("Failed to fetch tax details.");
      }
    } catch (error) {
      if (error.response?.status === 403) {
        window.location.replace("/Login");
      } else {
        toast.error("Error fetching data.");
      }
    }
  };

  const handleUpdate = async () => {
    if (!type || type.trim() === "") {
      toast.error("Display name is required");
      return;
    } else if (!/^[a-zA-Z]/.test(type)) {
      toast.error("Display name must start with a letter");
      return;
    } else if (!/^[a-zA-Z0-9 _-]+$/.test(type)) {
      toast.error("Enter a Valid Value");
      return;
    }

    if (!rate || isNaN(parseFloat(rate)) || parseFloat(rate) <= 0) {
      toast.error("Tax rate must be greater than 0.");
      return;
    }
    if (cess === undefined || cess === null || isNaN(parseFloat(cess))) {
      toast.error("Cess is required and must be a valid number.");
      return;
    }

    const payload = {
      type: type,
      rate: rate,
      cess: cess,
      entertainment_tax: entertainment,
      other_tax: otherTax,
    };

    try {
      const response = await API.updateTaxRate(id, payload);
      if (response.status === 200) {
        toast.success(response.data.message);
        bindGetTaxtRate();
        setTimeout(() => window.location.reload(), 2000);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          toast.error(
            error.response.data.message || "Bad Request: Please check your input."
          );
        } else if (error.response.status === 403) {
          window.location.replace("/Login");
        } else {
          toast.error(`Error ${error.response.status}: ${error.response.data.message}`);
        }
      } else if (error.request) {
        toast.error("No response from server. Please try again later.");
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    }
  };
const columns = [
  {
    name: "SrNo",
    selector: (row, index) => (currentPage - 1) * perPage + index + 1,
    sortable: true,
    width: "70px", // small fixed width
  },
  {
    name: "Action",
    cell: (row) => (
      <div
        key={row.id}
        className="navbar-menu-wrapper d-flex align-items-stretch"
        style={{ justifyContent: "center", alignItems: "center", display: "flex" }}
      >
        <ul className="navbar-nav navbar-nav-right">
          <li className="nav-item nav-profile1 dropdown">
            {/* <span
              className="nav-link mdi mdi-menu"
              style={{
                width: "30px",
                fontSize: "24px",
                color: "black",
                cursor: "pointer",
              }}
              id={`actionDropdown-${row.id}`}
              data-bs-toggle="dropdown"
              aria-expanded="false"
            ></span>
             */}
<span
  className="nav-link mdi mdi-menu"
  style={{
    width: "30px",
    fontSize: "24px",
    cursor: "pointer",
    color: row.is_active ? "black" : "#dc3545", // 🔹 black if active, red if deactivated
  }}
  id={`actionDropdown-${row.id}`}
  data-bs-toggle="dropdown"
  aria-expanded="false"
></span>

            <div
              className="dropdown-menu navbar-dropdown"
              aria-labelledby={`actionDropdown-${row.id}`}
            >
              <a className="dropdown-item">
                <button
                  onClick={() => handleGetData(row.id)}
                  className="btn btn-success btn-sm"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#myModalTaxView"
                >
                  View
                </button>
              </a>

              <div className="dropdown-divider"></div>

              <a className="dropdown-item">
                <button
                  onClick={() => handleGetData(row.id)}
                  className="btn btn-primary btn-sm"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#myModal"
                >
                  Edit
                </button>
              </a>

              <div className="dropdown-divider"></div>

              <a className="dropdown-item">
                {localStorage.getItem("location_id") !== row.id && (
                  <button
                    className={`btn btn-sm ${
                      row.is_active ? "btn-secondary" : "btn-info"
                    }`}
                    onClick={() => handleStatusToggle(row.id, row.is_active)}
                  >
                    {row.is_active ? "De-Activate" : "Activate"}
                  </button>
                )}
              </a>
            </div>
          </li>
        </ul>
      </div>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
    width: "160px", // fixed
  },
  { name: "Type", selector: (row) => row.type, sortable: true, minWidth: "200px" }, // large
  { name: "Rate", selector: (row) => row.rate, sortable: true, width: "120px" },
  { name: "Cess", selector: (row) => row.cess, width: "120px" },
  { name: "Entertainment Tax", selector: (row) => row.entertainment_tax, minWidth: "180px" },
  { name: "Other Tax", selector: (row) => row.other_tax, minWidth: "150px" },
  {
    name: "Status",
    selector: (row) => (row.is_active ? "Active" : "De-Activated"),
    sortable: true,
    width: "140px",
  },
  {
    name: "Created Date",
    selector: (row) => moment(row.createdAt).format("DD-MM-YYYY"),
    sortable: true,
    width: "140px",
  },
];

const conditionalRowStyles = [
  {
    when: (row) => !row.is_active, // if De-Activated
    style: {
      color: "#dc3545", // Bootstrap danger red
      fontWeight: 500,
      "&:hover": {
        color: "#dc3545", // keep red even on hover
      },
    },
  },
];

  return (
    <div>
      <div className="col-lg-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">Added Tax Rate</h4>
          </div>
          <div className="card-body">
            {/* Filter */}
            <div className="row mb-3">
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="ddSalesType" className="form-label">
                    Status
                  </label>
                  <select
                    className="form-select"
                    id="ddSalesType"
                    value={selectedStatus}
                    onChange={(e) => setSelectedStatus(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </div>
              </div>
            </div>

            {/* DataTable */}
            <DataTable
              columns={columns}
              data={taxRate}
              pagination
              paginationServer
              paginationTotalRows={totalRecords}
              paginationPerPage={perPage}
              paginationDefaultPage={currentPage}
              onChangePage={handlePageChange}
              highlightOnHover
              striped
              responsive
              className="table table-bordered"
              conditionalRowStyles={conditionalRowStyles}

            />
          </div>
        </div>
      </div>

      {/* --- Edit Modal --- */}
      <section>
        <div className="modal" id="myModal" data-bs-backdrop="static">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Update Tax Rate</h4>
                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6">
                    <label className="my-1">Display name <span style={{ color: "red" }}>*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={type}
                      onChange={(e) => setType(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="my-1">Rate <span style={{ color: "red" }}>*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={rate}
                      onChange={(e) => setRate(e.target.value)}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <label className="my-1">Cess <span style={{ color: "red" }}>*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={cess}
                      onChange={(e) => setCess(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="my-1">Entertainment Tax</label>
                    <input
                      type="text"
                      className="form-control"
                      value={entertainment}
                      onChange={(e) => setEntertainment(e.target.value)}
                    />
                  </div>
                </div>

                <div className="row my-3">
                  <div className="col-md-12">
                    <label className="my-1">Other Tax</label>
                    <input
                      type="text"
                      className="form-control"
                      value={otherTax}
                      onChange={(e) => setOtherTax(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary" onClick={handleUpdate}>
                  Update
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- View Modal --- */}
      <section>
        <div className="modal" id="myModalTaxView" data-bs-backdrop="static">
          <div className="modal-dialog modal-lg" style={{ width: "800px" }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Tax Rate Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <table className="table table-bordered text-center">
                  <thead>
                    <tr>
                      <th>Display Name</th>
                      <th>Rate</th>
                      <th>Cess</th>
                      <th>Entertainment Tax</th>
                    </tr>
                    <tr>
                      <td>{type}</td>
                      <td>{rate}</td>
                      <td>{cess}</td>
                      <td>{entertainment}</td>
                    </tr>
                    <tr>
                      <th>Other Tax</th>
                      <th>Status</th>
                      <th>Created Date</th>
                    </tr>
                    <tr>
                      <td>{otherTax}</td>
                      <td>{getStatus ? "Active" : "De-Activated"}</td>
                      <td>{moment(createdDate).format("DD-MM-YYYY")}</td>
                    </tr>
                  </thead>
                </table>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <ToastContainer /> */}
    </div>
  );
};

export default TaxRateList;

// old Code
// import React, { useEffect, useState } from "react";
// import API from "../Services/TaxRate"
// import moment from "moment";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const TaxRateList = () => {
//     const [taxRate, setTaxRate] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [totalRecords, setTotalRecords] = useState(0);
//     const perPage = 10;
//     const [id, setId] = useState([])
//     const [type, setType] = useState("")
//     const [rate, setRate] = useState("")
//     const [cess, setCess] = useState("")
//     const [entertainment, setEntertainment] = useState("")
//     const [otherTax, setOtherTax] = useState("")
//     const [getStatus, setGetStatus] = useState("")
//     const [createdDate, setCreatedDate] = useState("")
//     const [selectedStatus, setSelectedStatus] = useState("");


//     useEffect(() => {
//         bindGetTaxtRate();
//     }, [currentPage])
   
//     const bindGetTaxtRate = async () => {
//         try {
//             const basePayload = {
//                 limit: perPage,
//                 pageNumber: currentPage,
//                 is_recipe: 0,
//             };

//             if (selectedStatus !== "") {
//                 basePayload.is_active = selectedStatus;
//             }
//             const response = await API.getTaxRate(basePayload);
//             const details = response?.data?.data;

//             setTaxRate(details?.rows || []);
//             setTotalRecords(details?.count ?? 0);
//         } catch (error) {
//             toast.dismiss();
//             if (!error.response) {
//                 toast.error("Network error! Please check your internet connection.");
//             } else if (error.response.status === 403) {
//                 window.location.replace("/Login");
//                 toast.error("Authorization error. Redirecting to login.");
//             } else {
//                 toast.error("An unexpected error occurred. Please try again.");
//             }
//         }
//     };
//     const totalPages = Math.ceil(totalRecords / perPage);
//     const handlePageChange = (page) => {
//         if (page > 0 && page <= totalPages) {
//             setCurrentPage(page);
//             // bindGetTaxtRate();
//         }
//     };
//     const getPageNumbers = () => {
//         const maxVisible = 10;
//         const pageNumbers = [];
//         if (totalPages <= maxVisible) {
//             for (let i = 1; i <= totalPages; i++) {
//                 pageNumbers.push(i);
//             }
//         } else {
//             const left = Math.max(1, currentPage - 3);
//             const right = Math.min(totalPages, currentPage + 3);
//             if (left > 2) {
//                 pageNumbers.push(1, '...');
//             } else {
//                 for (let i = 1; i < left; i++) {
//                     pageNumbers.push(i);
//                 }
//             }
//             for (let i = left; i <= right; i++) {
//                 pageNumbers.push(i);
//             }
//             if (right < totalPages - 1) {
//                 pageNumbers.push('...', totalPages);
//             } else {
//                 for (let i = right + 1; i <= totalPages; i++) {
//                     pageNumbers.push(i);
//                 }
//             }
//         }
//         return pageNumbers;
//     };

//     const handleStatusToggle = async (id, currentStatus) => {
//         // console.log(".......",id,currentStatus)
//         const updatedStatus = !currentStatus;
//         try {
//             const response = await API.changeTaxStatus(id, updatedStatus);
//             // console.log('ddd', response);
//             if (response.status === 200) {
//                 setTaxRate((prevLocation) =>
//                     prevLocation.map((item) =>
//                         item.id === id ? { ...item, is_active: updatedStatus } : item
//                     )
//                 );
//                 toast.success(response.data.message);
//                 bindGetTaxtRate();

//             } else {
//                 toast.error("Error updating status:", response);
//                 toast.error("Failed to update the status. Please try again.");
//             }
//         } catch (error) {
//             // console.log('rr',error.response.status)
//             if (error.response.status === 403) {
//                 window.location.replace("/Login");
//             }
//             console.log("Error in status toggle:", error);
//             toast.error("Failed to update the status. Please try again.");
//         }
//     };

//     const handleGetData = async (id) => {
//         try {
//             setId(id);
//             const response = await API.getTaxRate({ id: id });
//             const fetchedData = response?.data.data.rows?.[0];
//             // console.log('fetchedData', fetchedData);
//             if (fetchedData) {
//                 setType(fetchedData.type)
//                 setRate(fetchedData.rate)
//                 setCess(fetchedData.cess)
//                 setGetStatus(fetchedData.is_active);
//                 setEntertainment(fetchedData.entertainment_tax)
//                 setOtherTax(fetchedData.other_tax)
//                 setCreatedDate(fetchedData?.createdAt)

//             } else {
//                 toast.error("Failed to fetch receipt details.");
//             }
//         } catch (error) {

//             if (error.response.status == 403) {
//                 window.location.replace("/Login");
//             }
//             else {
//                 toast.error(error)
//             }
//             // console.error("Error fetching data:", error);
//         }
//     };

//     const handleUpdate = async () => {

//         if (!type || type.trim() === '') {
//             toast.error("Display name is required");
//             return;
//         } else if (!/^[a-zA-Z]/.test(type)) {
//             toast.error("Display name must start with a letter");
//             return;
//         } else if (!/^[a-zA-Z0-9 _-]+$/.test(type)) {
//             toast.error("Enter a Valid Value");
//             return;
//         }

//         if (!rate || isNaN(parseFloat(rate)) || parseFloat(rate) <= 0) {
//             toast.error("Tax rate must be greater than 0.");
//             return;
//         }
//         if (cess === undefined || cess === null || isNaN(parseFloat(cess))) {
//             toast.error("Cess is required and must be a valid number.");
//             return;
//         }
//         const payload = {
//             type: type,
//             rate: rate,
//             cess: cess,
//             entertainment_tax: entertainment,
//             other_tax: otherTax
//         };
//         // console.log("payload data....", payload)
//         try {
//             const response = await API.updateTaxRate(id, payload);
//             if (response.status === 200) {
//                 toast.success(response.data.message);
//                 bindGetTaxtRate();
//                 setTimeout(() => window.location.reload(), 2000);
//             }
//         } catch (error) {
//             if (error.response) {
//                 if (error.response.status === 400) {
//                     toast.error(error.response.data.message || "Bad Request: Please check your input.");

//                 }
//                 else if (error.response.status === 403) {
//                     window.location.replace("/Login");
//                 }
//                 else {
//                     toast.error(`Error ${error.response.status}: ${error.response.data.message}`);

//                 }
//             } else if (error.request) {
//                 toast.error("No response from server. Please try again later.");

//             } else {
//                 toast.error("Something went wrong. Please try again.");

//             }
//         }
//     };
//     const handleSearchData = async () => {
//         setCurrentPage(1);
//         bindGetTaxtRate(1);
//     }
//     return (
//         <div>
//             <div className="col-lg-12 grid-margin stretch-card">
//                 <div className="card">
//                     <div className="card-header d-flex justify-content-between align-items-center">
//                         <h4 className="card-title mb-0">Added Tax Rate</h4>
//                     </div>
//                     <div className="card-body">
//                         <div className="row">
                           
//                             <div className="col-md-4">
//                                 <div className="form-group">
//                                     <label htmlFor="ddSalesType" className="form-label">
//                                         Status
//                                     </label>
//                                     <select
//                                         className="form-select"
//                                         id="ddSalesType"
//                                         value={selectedStatus}
//                                         onChange={(e) => setSelectedStatus(e.target.value)}>
//                                         <option value="">Select</option>
//                                         <option value="1">Active</option>
//                                         <option value="0">Inactive</option>
//                                     </select>
//                                 </div>
//                             </div>
//                             <div className="col-md-2">
//                                 <label></label>
//                                 <button onClick={handleSearchData} className="btn btn-success" type="button">Search</button>
//                             </div>
//                         </div>
//                         <div className="table-responsive text-center">
//                             <table className="table table-bordered">
//                                 <thead>
//                                     <tr>
//                                         <th>SrNo</th>
//                                         <th>Action</th>
//                                         <th>Type</th>
//                                         <th>Rate</th>
//                                         <th>Cess</th>
//                                         <th>Entertainment Tax</th>
//                                         <th>Other Tax</th>
//                                         <th>Status</th>
//                                         <th>Created-Date</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {taxRate.map((item, index) => (

//                                         <tr
//                                             key={item.id}
//                                             data-active={item?.is_active ? "true" : "false"}
//                                         >
//                                             <td>{(currentPage - 1) * perPage + index + 1}</td>

//                                             <td>
//                                                 <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
//                                                     <ul className="navbar-nav navbar-nav-right">
//                                                         <li className="nav-item nav-profile1">
//                                                             <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
//                                                                 <div className="nav-profile-text1">
//                                                                     <p className="mb-1 text-black">
//                                                                     </p>
//                                                                 </div>
//                                                             </span>
//                                                             <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
//                                                             <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
//                                                                 <a className="dropdown-item">
//                                                                     <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalTaxView">
//                                                                         View
//                                                                     </button>
//                                                                 </a>
//                                                                 <div className="dropdown-divider"></div>
//                                                                 <a className="dropdown-item">
//                                                                     <button onClick={() => handleGetData(item.id)}
//                                                                         className="btn btn-primary btn-sm" type="button"
//                                                                         data-bs-toggle="modal" data-bs-target="#myModal"
//                                                                     >
//                                                                         Edit
//                                                                     </button>
//                                                                 </a>
//                                                                 <div className="dropdown-divider"></div>
//                                                                 <a className="dropdown-item">
//                                                                     {localStorage.getItem("location_id") !== item.id && (
//                                                                         <button
//                                                                             className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
//                                                                             onClick={() => handleStatusToggle(item.id, item.is_active)}
//                                                                         >
//                                                                             {item.is_active ? "De-Activate" : "Activate"}
//                                                                         </button>
//                                                                     )}
//                                                                 </a>
//                                                             </div>
//                                                         </li>
//                                                     </ul>
//                                                 </div>
//                                             </td>
//                                             <td>{item.type}</td>
//                                             <td>{item.rate}</td>
//                                             <td>{item.cess}</td>
//                                             <td>{item.entertainment_tax}</td>
//                                             <td>{item.other_tax}</td>
//                                             <td>{item.is_active ? "Active" : "De-Activated"}</td>
//                                             <td>
//                                                 {moment(item.createdAt).format("DD-MM-YYYY")}
//                                             </td>
//                                         </tr>
//                                     ))}

//                                 </tbody>
//                             </table>
//                             <nav aria-label="Page navigation example">
//                                 <ul className="pagination justify-content-center mt-4">
//                                     {/* Previous Button */}
//                                     <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
//                                         <button
//                                             className="page-link"
//                                             onClick={() => handlePageChange(currentPage - 1)}
//                                             disabled={currentPage === 1}>
//                                             Previous
//                                         </button>
//                                     </li>
//                                     {/* Dynamic Pagination Buttons */}
//                                     {/* {Array.from({ length: totalPages }, (_, index) => (
//                                         <li
//                                             key={index + 1}
//                                             className={`page-item ${currentPage === index + 1 ? "active" : ""}`} >
//                                             <button
//                                                 className="page-link"
//                                                 onClick={() => handlePageChange(index + 1)} >
//                                                 {index + 1}
//                                             </button>
//                                         </li>
//                                     ))} */}
//                                     {getPageNumbers().map((page, index) => (
//                                         <li
//                                             key={index}
//                                             className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
//                                         >
//                                             {page === "..." ? (
//                                                 <span className="page-link">...</span>
//                                             ) : (
//                                                 <button className="page-link" onClick={() => handlePageChange(page)}>
//                                                     {page}
//                                                 </button>
//                                             )}
//                                         </li>
//                                     ))}

//                                     {/* Next Button */}
//                                     <li
//                                         className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
//                                         <button
//                                             className="page-link"
//                                             onClick={() => handlePageChange(currentPage + 1)}
//                                             disabled={currentPage === totalPages}
//                                         >
//                                             Next
//                                         </button>
//                                     </li>
//                                 </ul>
//                             </nav>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <section>
//                 <div className="modal" id="myModal" data-bs-backdrop="static">
//                     <div className="modal-dialog">
//                         <div className="modal-content">
//                             <div className="modal-header">
//                                 <h4 className="modal-title">Update Tax Rate</h4>
//                                 <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
//                             </div>
//                             <div className="modal-body">
//                                 <div className="row">
//                                     <div className="col-md-6">
//                                         <label className="my-1">Display name </label>
//                                         <input type="text" className="form-control"
//                                             // onChange={(e) => (e.target.value, "type")}
//                                             value={type}
//                                             onChange={(e) => setType(e.target.value)}
//                                         ></input>
//                                     </div>
//                                     <div className="col-md-6">
//                                         <label className="my-1">Rate </label>
//                                         <input type="text" className="form-control"
//                                             value={rate}
//                                             onChange={(e) => setRate(e.target.value)}></input>
//                                     </div>
//                                 </div>

//                                 <div className="row">
//                                     <div className="col-md-6">
//                                         <label className="my-1">Cess</label>
//                                         <input type="text" className="form-control"
//                                             value={cess}
//                                             onChange={(e) => setCess(e.target.value)}
//                                         ></input>
//                                     </div>
//                                     <div className="col-md-6">
//                                         <label className="my-1">Entertainment Tax</label>
//                                         <input type="text" className="form-control"
//                                             value={entertainment}
//                                             onChange={(e) => setEntertainment(e.target.value)}
//                                         ></input>
//                                     </div>
//                                 </div>

//                                 <div className="row  my-3">
//                                     <div className="col-md-12">
//                                         <label className="my-1">Other Tax</label>
//                                         <input type="text" className="form-control"
//                                             value={otherTax}
//                                             onChange={(e) => setOtherTax(e.target.value)}
//                                         ></input>
//                                     </div>
//                                 </div>

//                             </div>
//                             <div className="modal-footer">
//                                 <button className="btn btn-primary" onClick={handleUpdate} >Update</button>
//                                 <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//             <section>
//                 <div className="modal" id="myModalTaxView" data-bs-backdrop="static">
//                     <div className="modal-dialog modal-lg" style={{ width: "800px" }}>
//                         <div className="modal-content">
//                             <div class="modal-header">
//                                 <h5 class="modal-title">Tax Rate Details</h5>
//                                 <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
//                             </div>
//                             <div class="modal-body">
//                                 <div className="col-lg-12 grid-margin stretch-card">
//                                     <div className="card">
//                                         <div className="card-body">
//                                             <div className="table-responsive">
//                                                 <table className="table table-bordered text-center">
//                                                     <thead>
//                                                         <tr>
//                                                             <th>Display Name</th>
//                                                             <th>Rate</th>
//                                                             <th>Cess</th>
//                                                             <th>Entertainment Tax</th>
//                                                         </tr>
//                                                         <tr>
//                                                             <td>{type}</td>
//                                                             <td>{rate}</td>
//                                                             <td>{cess}</td>
//                                                             <td>{entertainment}</td>
//                                                         </tr>
//                                                         <tr>
//                                                             <th>Other Tax</th>
//                                                             <th>Status</th>
//                                                             <th>Created Date</th>
//                                                         </tr>

//                                                         <tr>
//                                                             <td>{otherTax}</td>
//                                                             <td>{getStatus ? "Active" : "De-Activated"}</td>
//                                                             <td>
//                                                                 {moment(createdDate).format("DD-MM-YYYY")}
//                                                             </td>
//                                                         </tr>
//                                                         {/* <tr>
//                                                             <td>{getStatus ? "True" : "False"}</td>

//                                                             <td>
//                                                                 {moment(getcreatedAt).format("DD-MM-YYYY")}
//                                                             </td>
//                                                             <td>
//                                                                 <img src={logoPreview} alt="Logo" width="50" height="50" />
//                                                             </td>
//                                                         </tr> */}
//                                                     </thead>
//                                                 </table>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div class="modal-footer">
//                                 <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>

//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//             {/* <ToastContainer /> */}
//         </div>
//     );
// };

// export default TaxRateList;
